import { useAppSelector, jaenAgent } from '../redux';
export const useSharedDraft = () => {
    const remote = useAppSelector(state => state.remote);
    return {
        enabled: Boolean(jaenAgent),
        site: jaenAgent?.site,
        saveState: remote?.saveState || 'idle',
        pending: remote?.outbox.length || 0,
        lastSavedAt: remote?.lastSavedAt,
        lastError: remote?.lastError,
        authors: remote?.authors || {},
        revision: remote?.revision,
        publishedRevision: remote?.publishedRevision,
        hasUnpublished: typeof remote?.revision === 'number' &&
            remote.revision > (remote.publishedRevision ?? 0),
        connection: remote?.connection || 'poll',
        discardedRevision: remote?.discardedRevision,
        discardedAt: remote?.discardedAt,
        discardedBy: remote?.discardedBy
    };
};
